import brands from "../brands.json";

const brand = process.env.REACT_APP_BRAND || "M10";

const COLOR_PRIMARY = brands[brand].colors.primary;
const COLOR_TEXT = brands[brand].colors.text;

export { COLOR_PRIMARY, COLOR_TEXT };
